import {Component, OnDestroy, OnInit} from "@angular/core";
import {LoggerService} from "../common/logger.service";
import {BaseComponent} from "../base.component";
import {UserService} from "../common/user.service";
import {SkinAnalyzerService} from "./skin-analyzer.service";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {map} from "rxjs/operators";

@Component({
    selector: 'skin-analyzer',
    templateUrl: './skin-analyzer.component.html',
    styleUrls: ['./skin-analyzer.component.scss'],
    standalone: false
})
export class SkinAnalyzerComponent extends BaseComponent implements OnInit, OnDestroy {

    subscriptions: Subscription = new Subscription();

    constructor(
        private userService: UserService,
        loggerService: LoggerService,
        private skinAnalyzerService: SkinAnalyzerService,
        private router: Router,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.initSkinConfigLoader();
    }

    initSkinConfigLoader() {
        this.subscriptions.add(
            this.userService.getShopUser().pipe(
                map(shopUser => {
                    this.skinAnalyzerService.initSkinAnalyzer(shopUser, this.router);
                })
            ).subscribe()
        );
    }

    ngOnDestroy(): void {
        this.log.debug("Destroy");
        this.subscriptions.unsubscribe();
    }

    startAnalyzer() {
        this.log.debug("Start Analyzer");
        this.subscriptions.add(
            this.skinAnalyzerService.startAnalyzerFresh().subscribe()
        );
    }

}
